const awsAuthErrorMessages = {
    NO_CURRENT_USER: 'No current user',
    USER_PASSWORD_EXPIRED: 'USER_PASSWORD_EXPIRED',
    USER_IS_LOCKED_OUT: 'USER_IS_LOCKED_OUT',
};

export default awsAuthErrorMessages;
